module.exports = __webpack_public_path__ + "media/scholarship_winners/maitlyn-sw-f823e7e3.png";